import { useState } from 'react';
import { IQuoteJson, IUpdateModelQuoteDownload } from 'types';

const useUpdateModelQuoteDownload = () => {
  const [quotePdfUrl, setQuotePdfUrl] = useState<string>('');
  const [quoteJson, setQuoteJson] = useState<IQuoteJson>();

  const handleUpdateModelQuoteDownload = async (
    { jobId, results: { outputQuotePdf, outputQuoteJson } }: IUpdateModelQuoteDownload,
    allowQuoteDownload: boolean
  ) => {
    if (!allowQuoteDownload || !jobId) return;

    setQuotePdfUrl(outputQuotePdf.url);
    setQuoteJson(outputQuoteJson);
  };

  return [
    handleUpdateModelQuoteDownload,
    {
      quotePdfUrl,
      quoteJson,
    },
  ] as const;
};

export { useUpdateModelQuoteDownload };
